export default __webpack_public_path__ + "static/media/img_bg_have_questions.1be70188.png";